import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

// useState that survives reloads, scoped per user and key (localStorage).
export function usePersistedState(key, initial) {
  const { user } = useAuth();
  const k = `rp:${user?.id || "anon"}:${key}`;
  const [val, setVal] = useState(() => { try { const raw = localStorage.getItem(k); return raw === null ? initial : JSON.parse(raw); } catch { return initial; } });
  useEffect(() => { try { if (val === null || val === undefined) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(val)); } catch { /* ignore */ } }, [k, val]);
  return [val, setVal];
}
